import { CommonModule } from '@angular/common';
import { Component, inject, signal } from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { ModuleTabsComponent } from './components/module-tabs/module-tabs.component';
import { MatSelectModule } from '@angular/material/select';
import { SearchSummaryCardComponent } from '@shared/components/domain/search-summary-card/search-summary-card.component';
import { ToggleButtonComponent } from '@shared/components/ui/toggle-button/toggle-button.component';
import { ToggleButtonOptionDirective } from '@shared/components/ui/toggle-button/toggle-button-option.directive';
import { StockGridIconComponent } from '@shared/components/ui/icons/stock-grid/stock-grid-icon.component';
import { StoreIconComponent } from '@shared/components/ui/icons/store/store-icon.component';
import { RouteStateService } from '@core/services/route-state.service';
import { UserDropdownComponent } from './components/user-dropdown/user-dropdown.component';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    ModuleTabsComponent,
    MatSelectModule,
    SearchSummaryCardComponent,
    ToggleButtonComponent,
    ToggleButtonOptionDirective,
    StockGridIconComponent,
    StoreIconComponent,
    UserDropdownComponent,
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent {
  private readonly routeState = inject(RouteStateService);

  togglePaths = signal<Record<string, string>>({
    stock: '/stock-physical',
    store: '/search-stores',
  });

  getTenantPath(basePath: string): string {
    const tenantId = this.routeState.getRouteParam('tenantId');
    return tenantId ? `${basePath}/${tenantId}` : basePath;
  }
}
